import type { SVGProps } from 'react';

export function KingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 0c.275 0 .541.102.747.286.206.185.338.439.37.715l.008.132V3.4h2.25c.287 0 .563.11.771.31a1.137 1.137 0 0 1-.64 1.949l-.131.008h-2.25v2.992a5 5 0 0 1 2.287-.832l.27-.02.255-.007a5.03 5.03 0 0 1 3.58 1.494c.47.473.843 1.036 1.098 1.654a5.126 5.126 0 0 1-.93 5.377 5.05 5.05 0 0 1-3.257 1.65l-.244.018-.247.007H8.063c-.79 0-1.57-.186-2.276-.545a5.1 5.1 0 0 1-1.79-1.517 5.12 5.12 0 0 1-.778-4.52c.23-.761.633-1.459 1.179-2.035a5.06 5.06 0 0 1 1.96-1.285 5.03 5.03 0 0 1 4.52.562l-.002-2.993h-2.25a1.12 1.12 0 0 1-.771-.31 1.137 1.137 0 0 1 .64-1.95l.131-.007h2.25V1.133c0-.3.118-.589.33-.801A1.12 1.12 0 0 1 12 0M18.858 19H5.143a1.23 1.23 0 0 0-.808.293A.94.94 0 0 0 4 20c0 .53.24 1.04.67 1.414.428.375 1.01.586 1.616.586h11.429c.56 0 1.1-.18 1.52-.506.418-.326.686-.775.75-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.242-.344 1.2 1.2 0 0 0-.379-.232 1.3 1.3 0 0 0-.452-.082" />
    </svg>
  );
}
